import React from "react";
import PhoneInput from "../../ui/PhoneInput";
import QuestionFrame from "./QuestionFrame";

/**
 * Phone question backed by the shared region + number input. Stores E.164.
 *
 * @param {Object} props
 * @param {object} props.question
 * @param {string} [props.value]
 * @param {function(string): void} props.onChange
 * @param {string} [props.error]
 * @param {boolean} [props.readOnly]
 * @param {boolean} [props.showRequired]
 * @returns {JSX.Element}
 */
export default function PhoneQuestion({ question, value = "", onChange, error, readOnly, showRequired }) {
  const fieldId = `survey-q-${question.id}`;
  return (
    <QuestionFrame question={question} error={error} showRequired={showRequired}>
      <PhoneInput
        id={fieldId}
        value={value || ""}
        disabled={readOnly}
        invalid={Boolean(error)}
        placeholder={question.placeholder || "Phone number"}
        onChange={onChange}
      />
    </QuestionFrame>
  );
}
